import { useAppConfig } from 'state/appConfig';

/**
 * useIsNetChannel
 * Gets the session storage item
 */
export const useIsNetChannel = () => {
  const { channel } = useAppConfig();

  return channel === 'hsbcnet';
};
